import { HttpServiceResponse } from '../../shared'
import AbstractProvider from '../../shared/abstract.provider'
import { AccEntryOperTypes } from '../models/accEntry.types'

export class AccEntryOperProvider extends AbstractProvider {
  urlPath = 'acc_entry_oper_api'

  public oper<T>(action: AccEntryOperTypes, params: Record<string, any>): Promise<HttpServiceResponse<T>> {
    delete params.action
    const query = this.query.stringify({
      action,
      ...params,
    })

    return this.http.post(`${this.url}?${query}`)
  }
}
